export default __webpack_public_path__ + "static/media/pm.bce7078d.jpg";